<div class="container text-center pt-5">
  <div class="row my-5">
    <div class="col-md-12 flex-column d-flex align-items-center">
      <div
        style="width: 500px; height: 64px"
        class="mw-100 mb-5 position-relative"
      >
        <img
          ngSrc="/assets/logos/pkspot/pkspot_logo_oneline_dark.png"
          alt="PK Spot"
          fill
          class="object-fit-contain"
          priority
        />
      </div>

      <h2 class="mat-title-large" i18n>
        The spot for Parkour and Freerunning.
      </h2>
      <h3 class="mat-headline-medium" i18n>Discover, Train, Share.</h3>

      <p class="mat-body-medium" i18n>
        Discover spots and fellow athletes, plan training sessions with your
        friends and share achievements and memories with them and the world.
      </p>
    </div>
  </div>
  <div class="row mb-5">
    <!-- <div class="col-md-4 mb-4">
      <h4 class="mat-h2">Our Ad policy</h4>
      <p class="mat-body">
        We are currently not serving ads. However, this will likely change in
        the future. This is also reflected in our terms and conditions and
        privacy policy.
      </p>
      <p class="mat-body">
        Our plan is to only have parkour related ads on this platform. It is our
        dream to support Parkour and Freerunning brands, and be supported by
        them.
      </p>
    </div> -->
    <div class="col-md-4"></div>
    <div class="col-md-4 mb-4">
      <h4 class="mat-headline-small">Open-Source</h4>
      <p class="mat-body-medium" i18n>
        This project is Open-Source! Our code is licensed under the
        <b>MIT License</b>.
      </p>
      <div class="d-flex flex-column align-items-center">
        <a
          mat-stroked-button
          color="default"
          href="https://github.com/lukasbuehler/pkfrspot"
          class="link-button mb-2"
        >
          <mat-icon>code</mat-icon>
          Github
        </a>
        <a
          mat-stroked-button
          color="default"
          href="https://github.com/lukasbuehler/pkfrspot/blob/main/LICENSE"
          class="link-button"
          i18n
        >
          <mat-icon>receipt_long</mat-icon>
          View License
        </a>
      </div>
    </div>
  </div>
  <div class="row justify-content-center">
    <div class="col-md-12 mb-5">
      <h2 class="mat-headline-medium mb-4" i18n>Partners</h2>
      <div class="partner-grid">
        <a href="https://sph.ethz.ch/">
          <div class="sph-background rounded position-relative">
            <img
              ngSrc="assets/logos/sph.svg"
              title="ETH Student Project House"
              alt="ETH Student Project House"
              fill
            />
          </div>
        </a>
        <a href="https://spka.ch/">
          <div class="bg-white rounded p-5">
            <div class="h-100 w-100 position-relative">
              <img
                class="object-fit-contain"
                ngSrc="assets/logos/spka_white.jpg"
                title="Swiss Parkour Association (SPKA)"
                alt="Swiss Parkour Associaton"
                fill
              />
            </div>
          </div>
        </a>
      </div>
    </div>
  </div>
  <div class="row mb-5">
    <div class="col-md-12">
      <h2 class="mat-headline-medium mb-4" i18n>Contributors</h2>
      <div class="credit-grid pb-5">
        <div
          class="mat-card rounded mat-elevation-z0 border p-4 d-flex flex-column"
        >
          <div class="mat-card-title mat-title-large">Lukas Bühler</div>
          <div class="mat-card-content mat-body-large" i18n>Lead developer</div>
          <!-- <div
          class="d-flex flex-grow-1 flex-row justify-content-center align-items-center gap-3 pt-4"
        >
          <a href="https://github.com/lukasbuehler">
            <img ngSrc="assets/logos/github.svg" title="Github" alt="Github" />
          </a>
          <a href="https://www.instagram.com/lukasbuehler_">
            <img
              ngSrc="assets/logos/instagram.svg"
              title="Instagram"
              alt="Instagram"
            />
          </a>
          <a href="mailto:contact@lukasbuehler.ch">
            <mat-icon class="mat-icon-link">mail</mat-icon>
          </a>
        </div> -->
        </div>
        <div class="mat-card rounded mat-elevation-z0 border p-4">
          <div class="mat-card-title mat-title-large">Shadi Vandeventer</div>
          <div class="mat-card-content mat-body-medium" i18n>Testing</div>
        </div>
        <div class="mat-card rounded mat-elevation-z0 border p-4">
          <div class="mat-card-title mat-title-large">Alain Rohner</div>
          <div class="mat-card-content mat-body-medium" i18n>
            Testing, UI/UX Advisor
          </div>
        </div>
        <div class="mat-card rounded mat-elevation-z0 border p-4">
          <div class="mat-card-content">
            <p class="mat-body-medium" i18n>
              Join our community of Parkour and Freerunning enthusiasts!
              Contribute your ideas, report bugs, and provide feedback to help
              us improve this platform together!
            </p>
            <a
              mat-stroked-button
              color="default"
              href="https://discord.gg/Th5vx4KnQb"
              class="link-button mb-2"
              i18n
            >
              <mat-icon>sports_esports</mat-icon>
              Discord
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
